module.exports = __webpack_public_path__ + "static/media/medal.1ae49ef1.png";